import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@/app/core/services/auth/auth.service';
import { PermissionService } from '@/app/core/services/permission/permission.service';
import { environment } from '@/environments/environment';

export const nonAuthGuard: CanActivateFn = () => {
  // TEMP: allow reaching login screens even if a token exists (dev bypass mode).
  if (environment.featureFlags?.bypassAuth) return true;

  const authService = inject(AuthService);
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  const redirectPath = permissionService.getFirstAccessibleRoute();
  return router.createUrlTree([redirectPath]);
};
